import cx from 'classnames'
import { PortableText as BasePortableText } from '@portabletext/react'
import {
  type ArbitraryTypedObject,
  type PortableTextBlock as BaesPortableTextBlock,
} from '@portabletext/types'

import ColoredText from './portable-text/colored-text'
import Figure from './portable-text/figure'
import Link from './portable-text/link'
import VideoEmbed from './portable-text/video-embed'

type PortableTextBlock = BaesPortableTextBlock | ArbitraryTypedObject

interface PortableTextProps {
  content: PortableTextBlock[]
  className?: string
}

const PortableText = ({ content, className }: PortableTextProps) => {
  return (
    <div
      className={cx(
        '[&>*+*]:mt-2.5',
        '[&>*+.video]:mt-4 [&>*+.photo]:mt-4 [&>.video+*]:mt-4 [&>.photo+*]:mt-4',
        className,
      )}
    >
      <BasePortableText
        value={content}
        components={{
          block: {
            none: ({ children }) => <>{children}</>,
            small: ({ children }) => <p className="is-small">{children}</p>,
            normal: ({ children }) => <p>{children}</p>,
            large: ({ children }) => <p className="is-large">{children}</p>,
            h1: ({ children }) => <h1>{children}</h1>,
            h2: ({ children }) => <h2>{children}</h2>,
            h3: ({ children }) => <h3>{children}</h3>,
            h4: ({ children }) => <h4>{children}</h4>,
            h5: ({ children }) => <h5>{children}</h5>,
            h1mock: ({ children }) => <p className="is-h1">{children}</p>,
            h2mock: ({ children }) => <p className="is-h2">{children}</p>,
            h3mock: ({ children }) => <p className="is-h3">{children}</p>,
            h4mock: ({ children }) => <p className="is-h4">{children}</p>,
            h5mock: ({ children }) => <p className="is-h5">{children}</p>,
          },
          types: {
            frameBuilderFigure: Figure,
            videoEmbed: VideoEmbed,
          },
          marks: {
            link: Link,
            textColor: ColoredText,
          },
        }}
      />
    </div>
  )
}

export default PortableText
